export default __webpack_public_path__ + "static/media/DraMichelle.85fc3854.png";